import { format, parseISO } from 'date-fns';
import { vi } from 'date-fns/locale';

export const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'dd/MM/yyyy HH:mm:ss', { locale: vi });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const formatDateOnly = (dateString) => {
  if (!dateString) return '';
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'dd/MM/yyyy', { locale: vi });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const formatTimeOnly = (dateString) => {
  if (!dateString) return '';
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'HH:mm', { locale: vi });
  } catch (error) {
    console.error('Error formatting time:', error);
    return '';
  }
};

export const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return '';
  try {
    const start = typeof startDate === 'string' ? parseISO(startDate) : startDate;
    const end = typeof endDate === 'string' ? parseISO(endDate) : endDate;
    return `${format(start, 'dd/MM/yyyy', { locale: vi })} - ${format(end, 'dd/MM/yyyy', { locale: vi })}`;
  } catch (error) {
    console.error('Error formatting date range:', error);
    return '';
  }
};

export const formatToHHmmss = (timeStr) => {
  if (!timeStr) return '';
  // Nếu đã có đủ hh:mm:ss thì trả về luôn
  if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) return timeStr;
  // Nếu chỉ có hh:mm thì thêm :00
  if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr + ':00';
  // Nếu không đúng định dạng thì trả về chuỗi gốc
  return timeStr;
}; 